const Welcome = ({ onSignIn, onSignUp }) => {
  return (
    <div className="welcome-container">
      <h1>Welcome to Mastery Method LLC</h1>
      <p className="welcome-text">
        Your Journey to Trading Excellence Begins Here
      </p>
      <div className="button-group">
        <button onClick={onSignUp} className="btn-secondary">
          Sign Up
        </button>
        <button onClick={onSignIn}>Sign In</button>
      </div>
    </div>
  );
};

export default Welcome;
